<template>
  <div class="inspection-point-action">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" :content="content" />
    <ml-tip class="scroll-box" :showHeader="false" style="border: 0">
      <el-scrollbar :height="tabberHeight(185)">
        <!-- 点位表单 -->
        <ml-form
          ref="pointFormRef"
          labelWidth="200px"
          style="width: 1200px; margin: 40px auto"
          :model="itemData"
          :rules="formRules"
        >
          <el-row>
            <el-col :span="12">
              <!-- 点位编号 -->
              <ml-input
                prop="pointCode"
                label="点位编号:"
                placeholder="请输入点位编号"
                v-model.trim="itemData.pointCode"
              />
            </el-col>
            <el-col :span="12">
              <!-- 点位名称 -->
              <ml-input
                prop="pointName"
                label="点位名称:"
                placeholder="请输入点位名称"
                v-model.trim="itemData.pointName"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <!-- 阿米巴 -->
              <ml-select
                prop="companyId"
                placeholder="请选择阿米巴"
                :options="unitOptions"
                label="阿米巴:"
                keyName="companyId"
                labelName="companyName"
                valueName="companyId"
                v-model="itemData.companyId"
                @change="selectUnit"
              />
            </el-col>
            <el-col :span="12">
              <!-- 所属项目 -->
              <ml-select
                prop="projectId"
                placeholder="请选择所属项目"
                :options="projectData"
                label="所属项目:"
                keyName="projectId"
                labelName="projectName"
                valueName="projectId"
                v-model="itemData.projectId"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <!-- 点位分类 -->
              <ml-select
                prop="pointType"
                placeholder="请选择点位分类"
                :options="pointTypeOptions"
                label="点位分类:"
                keyName="value"
                labelName="label"
                valueName="value"
                v-model="itemData.pointType"
              />
            </el-col>
            <el-col :span="12">
              <!-- 状态 -->
              <ml-select
                prop="dataStatus"
                placeholder="请选择状态"
                :options="statusOptions"
                label="状态:"
                keyName="value"
                labelName="label"
                valueName="value"
                v-model="itemData.dataStatus"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <!-- 经度 -->
              <ml-input
                prop="longitude"
                label="经度:"
                placeholder="请输入或点击地图选取"
                v-model.trim="itemData.longitude"
              />
            </el-col>
            <el-col :span="12">
              <!-- 纬度 -->
              <ml-input
                prop="latitude"
                label="纬度:"
                placeholder="请输入或点击地图选取"
                v-model.trim="itemData.latitude"
              />
            </el-col>
          </el-row>

          <!-- 地址 -->
          <ml-input
            prop="pointAddr"
            label="地址:"
            placeholder="点击地图自动获取地址，或手动输入"
            v-model.trim="itemData.pointAddr"
          />

          <!-- 地图标点（高德地图，与巡检详情打卡轨迹地图统一坐标系 GCJ-02） -->
          <el-form-item>
            <div class="tmap-box-main">
              <div id="pointMap" class="point-map"></div>
              <!-- 地图搜索：输入关键词，选中候选地点后自动回填经纬度并定位 -->
              <div class="point-map-search">
                <el-input
                  v-model="searchValue"
                  placeholder="搜索地点快速定位，如：大厦、路口、村"
                  prefix-icon="el-icon-search"
                  clearable
                  @input="searchInputHandle"
                />
                <div class="point-map-search-list" v-if="searchList.length > 0">
                  <div
                    class="point-map-search-item"
                    v-for="(item, index) in searchList"
                    :key="index"
                    @click="selectSearchResult(item)"
                  >
                    <p class="name">{{ item.name }}</p>
                    <p class="addr">{{ item.district }}{{ item.address || '' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>

          <!-- 提交按钮 -->
          <ml-button
            submitText="提交"
            submitIcon="el-icon-upload2"
            cancelIcon="el-icon-circle-close"
            cancelText="返回上一页"
            @click-submit="saveHandle"
            @click-cancel="cancelHandle"
          />
        </ml-form>
      </el-scrollbar>
    </ml-tip>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getTabberData, tabberHeight } from '@/utils'
import { tampCityLocaltionKey } from '@API'
import axios from 'axios'
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  name: 'InspectionPointAction',
  setup() {
    const { commit, getters, dispatch } = useStore()
    const route = useRoute()
    const router = useRouter()
    const isBusinessDepartment = computed(() => getters.isBusinessDepartment)

    // 获取路径参数
    const { pointId } = route.query
    // 设置导航标题
    const content = ref(pointId ? '编辑巡检点位' : '新增巡检点位')

    // 表单数据
    const pointFormRef = ref(null)
    const itemData = reactive({
      id: '',
      pointCode: '',
      pointName: '',
      companyId: '',
      projectId: '',
      longitude: '',
      latitude: '',
      pointAddr: '',
      pointType: '',
      dataStatus: '1'
    })

    // 表单校验规则
    const formRules = reactive({
      pointCode: [{ required: true, message: '请输入点位编号', trigger: 'blur' }],
      pointName: [{ required: true, message: '请输入点位名称', trigger: 'blur' }],
      companyId: [{ required: true, message: '请选择阿米巴', trigger: 'blur' }],
      projectId: [{ required: true, message: '请选择所属项目', trigger: 'blur' }],
      longitude: [
        { required: true, message: '请输入经度', trigger: 'blur' },
        {
          pattern:
            /^-?(180(\.0{6,8})?|1[0-7][0-9](\.\d{6,8})?|[1-9][0-9](\.\d{6,8})?|[1-9](\.\d{6,8})?)$/,
          message: '经度格式不正确, 必须精确到6位小数',
          trigger: 'blur'
        }
      ],
      latitude: [
        { required: true, message: '请输入纬度', trigger: 'blur' },
        {
          pattern: /^-?(90(\.0{6,8})?|[1-8][0-9](\.\d{6,8})?|[1-9](\.\d{6,8})?)$/,
          message: '纬度格式不正确，必须精确到6位小数',
          trigger: 'blur'
        }
      ],
      pointType: [{ required: true, message: '请选择点位分类', trigger: 'blur' }],
      dataStatus: [{ required: true, message: '请选择状态', trigger: 'blur' }]
    })

    // 点位分类下拉选项
    const pointTypeOptions = ref([
      { value: '1', label: '硬件设备' },
      { value: '2', label: '建筑物' },
      { value: '3', label: '地理位置' }
    ])
    // 状态下拉选项
    const statusOptions = ref([
      { value: '1', label: '启用' },
      { value: '0', label: '停用' }
    ])

    // 单位名下拉列表
    const unitOptions = ref([])
    const selectUnit = () => {
      itemData.projectId = ''
      projectData.value = []
    }
    watch(
      () => itemData.companyId,
      newvalue => {
        getProjectData(newvalue)
      }
    )
    // 所属项目配置
    const projectData = ref([])
    // 处理所属项目
    const getProjectData = async companyId => {
      const projectParams = { projectStatus: 'Y' }
      if (isBusinessDepartment.value) {
        projectParams.companyId = companyId
      }
      const { data } = await getTabberData(dispatch, 'fetchGetProjectsByCompany', projectParams)
      projectData.value = data || []
    }

    /* 高德地图（点击选点） 开始 **********************************/
    let pointMap = null
    let pointMarker = null

    // 加载高德地图（若全局已加载则复用，避免重复 load 报错）
    const ensureAMap = async () => {
      if (window.AMap) return window.AMap
      return await AMapLoader.load({
        key: '8fb96b5c1d0841623c6a9aa5cde6ecee',
        version: '1.4.15',
        plugins: ['AMap.Scale', 'AMap.Autocomplete', 'AMap.PlaceSearch']
      })
    }

    // 在地图上更新点位标记
    const updateMapMarker = () => {
      const lng = parseFloat(itemData.longitude)
      const lat = parseFloat(itemData.latitude)
      if (!window.AMap || !pointMap || isNaN(lng) || isNaN(lat) || (lng === 0 && lat === 0)) {
        return
      }
      const position = [lng, lat]
      if (pointMarker) {
        pointMarker.setPosition(position)
      } else {
        pointMarker = new window.AMap.Marker({
          position,
          map: pointMap
        })
      }
      pointMap.setCenter(position)
    }

    // 初始化高德地图
    const initPointMap = async () => {
      let AMap
      try {
        AMap = await ensureAMap()
      } catch (e) {
        console.error('[pointMap] 高德地图加载失败', e)
        return
      }
      if (pointMap) return
      pointMap = new AMap.Map('pointMap', {
        zoom: 15,
        resizeEnable: true
      })
      pointMap.addControl(new AMap.Scale())
      // 点击地图选取坐标（GCJ-02，与逆地理编码及打卡轨迹地图坐标系一致）
      pointMap.on('click', e => {
        mapClick([e.lnglat.getLng().toFixed(6), e.lnglat.getLat().toFixed(6)])
      })
      // 编辑模式：已有经纬度时展示标记
      if (itemData.longitude && itemData.latitude) {
        updateMapMarker()
      }
    }
    /* 高德地图（点击选点） 结束 **********************************/

    /* 地图搜索 开始 **********************************/
    const searchValue = ref('')
    const searchList = ref([])
    let autoComplete = null
    let searchTimer = null

    // 兼容获取提示词坐标（高德返回对象或字符串两种形式）
    const getTipLngLat = loc => {
      if (!loc) return null
      let lng, lat
      if (typeof loc === 'string') {
        const arr = loc.split(',')
        lng = parseFloat(arr[0])
        lat = parseFloat(arr[1])
      } else {
        lng = typeof loc.getLng === 'function' ? loc.getLng() : parseFloat(loc.lng)
        lat = typeof loc.getLat === 'function' ? loc.getLat() : parseFloat(loc.lat)
      }
      if (isNaN(lng) || isNaN(lat) || (lng === 0 && lat === 0)) return null
      return [Number(lng.toFixed(6)), Number(lat.toFixed(6))]
    }

    // 确保输入提示插件已加载（兼容 window.AMap 已存在但插件未加载的场景）
    const ensureAutoComplete = async () => {
      if (autoComplete) return autoComplete
      const AMap = await ensureAMap()
      await new Promise(resolve => {
        if (AMap.Autocomplete) {
          resolve()
          return
        }
        AMap.plugin('AMap.Autocomplete', () => resolve())
      })
      autoComplete = new AMap.Autocomplete()
      return autoComplete
    }

    // 输入防抖搜索
    const searchInputHandle = value => {
      if (searchTimer) clearTimeout(searchTimer)
      const keyword = (value || '').trim()
      if (!keyword) {
        searchList.value = []
        return
      }
      searchTimer = setTimeout(async () => {
        try {
          const inst = await ensureAutoComplete()
          inst.search(keyword, (status, result) => {
            if (status === 'complete' && result && result.tips && result.tips.length > 0) {
              searchList.value = result.tips.filter(tip => getTipLngLat(tip.location)).slice(0, 8)
            } else {
              searchList.value = []
            }
          })
        } catch (e) {
          console.log('[pointMap] 搜索失败', e)
        }
      }, 300)
    }

    // 选中搜索结果：回填经纬度 → 逆地理编码地址 → watch 自动打点居中
    const selectSearchResult = item => {
      const lnglat = getTipLngLat(item.location)
      searchList.value = []
      if (lnglat) {
        mapClick(lnglat)
      }
    }
    /* 地图搜索 结束 **********************************/

    // 地图点击：获取经纬度 → 逆地理编码获取地址
    const mapClick = async c => {
      // 点击地图时收起搜索下拉
      searchList.value = []
      itemData.longitude = c[0]
      itemData.latitude = c[1]
      // 通过经纬度逆地理编码获取地址
      try {
        const url = `https://restapi.amap.com/v3/geocode/regeo?location=${c[0]},${c[1]}&output=json&key=${tampCityLocaltionKey}`
        const { data } = await axios.get(url)
        if (data.status === '1' && data.regeocode) {
          itemData.pointAddr = data.regeocode.formatted_address || ''
        }
      } catch (e) {
        console.log('逆地理编码获取地址失败', e)
      }
    }

    // 经纬度手动输入时同步地图标点
    watch(
      () => [itemData.longitude, itemData.latitude],
      ([lng, lat]) => {
        if (lng && lat) {
          updateMapMarker()
        } else if (pointMarker && pointMap) {
          pointMarker.setMap(null)
          pointMarker = null
        }
      }
    )

    // 提交表单
    const saveHandle = () => {
      pointFormRef.value.CustomFormRef.validate().then(() => {
        dispatch('fetchInsertOrUpdateInspectionPoint', itemData).then(data => {
          if (data.code === 200) {
            commit('setError', {
              status: true,
              title: data.message,
              message: '正在获取新的数据...',
              type: 'success'
            })
            router.push({ path: '/inspectionPointManage' })
          }
        })
      })
    }
    // 取消
    const cancelHandle = () => {
      router.push({ path: '/inspectionPointManage' })
    }

    onMounted(async () => {
      // 初始化高德地图
      initPointMap()
      // 获取单位名
      const { data } = await getTabberData(dispatch, 'fetchGetCompanyInfos', {
        noCompanyCode: 'business_department'
      })
      unitOptions.value = data || []

      // 编辑模式：加载已有数据
      if (pointId) {
        const res = await dispatch('fetchGetInspectionPointInfo', { id: pointId })
        if (res && res.code === 200 && res.data) {
          const d = res.data
          itemData.id = d.id
          itemData.pointCode = d.pointCode
          itemData.pointName = d.pointName
          itemData.companyId = d.companyId
          itemData.projectId = d.projectId
          itemData.longitude = d.longitude
          itemData.latitude = d.latitude
          itemData.pointAddr = d.pointAddr
          itemData.pointType = d.pointType
          itemData.dataStatus = d.dataStatus
        }
      }
    })

    return {
      content,
      pointFormRef,
      itemData,
      formRules,
      unitOptions,
      projectData,
      selectUnit,
      pointTypeOptions,
      statusOptions,
      searchValue,
      searchList,
      searchInputHandle,
      selectSearchResult,
      mapClick,
      saveHandle,
      cancelHandle,
      tabberHeight
    }
  }
}
</script>

<style lang="scss">
.inspection-point-action {
  .tmap-box-main {
    position: relative;
    width: 860px;
    height: 480px;
    .point-map {
      width: 100%;
      height: 100%;
    }
    /* 地图搜索框 */
    .point-map-search {
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 200;
      width: 320px;
      .point-map-search-list {
        margin-top: 4px;
        max-height: 260px;
        overflow-y: auto;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        .point-map-search-item {
          padding: 8px 12px;
          cursor: pointer;
          border-bottom: 1px solid #f0f0f0;
          &:hover {
            background: #f5f7fa;
          }
          &:last-child {
            border-bottom: 0;
          }
          .name {
            margin: 0;
            font-size: 14px;
            color: #333;
            line-height: 1.4;
          }
          .addr {
            margin: 0;
            font-size: 12px;
            color: #999;
            line-height: 1.4;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
